export class LoginModels {

    public UserName: string;
    public Password: string;
    public UserTypeId: number;
    public RoleId: number;
    
}